import { DebugSection } from '../DebugSection';
import { useErrorBuffer } from '../hooks/useErrorBuffer';
import { clearErrorBuffer } from '../services/errorBufferStore';

export interface ErrorsSectionProps { searchTerm?: string }

export function ErrorsSection({ searchTerm }: ErrorsSectionProps): JSX.Element {
  const entries = useErrorBuffer();
  const term = (searchTerm ?? '').trim().toLowerCase();
  const visible = term
    ? entries.filter((e) => `${e.kind} ${e.message} ${e.stack ?? ''}`.toLowerCase().includes(term))
    : entries;

  const errCount = entries.filter((e) => e.level === 'error').length;
  const warnCount = entries.filter((e) => e.level === 'warn').length;

  const rightAction = (
    <button
      type="button"
      className="pcb-debug-action-btn"
      onClick={() => clearErrorBuffer()}
      title="Clear error buffer"
    >
      Clear
    </button>
  );

  return (
    <DebugSection
      id="errors"
      title="9. Errors + warnings"
      count={entries.length}
      searchTerm={searchTerm}
      rightAction={rightAction}
    >
      <div className="pcb-debug-stat-row">
        <span><b>errors</b> {errCount}</span>
        <span><b>warnings</b> {warnCount}</span>
      </div>
      {visible.length === 0 ? (
        <div className="pcb-debug-empty">No errors or warnings captured.</div>
      ) : (
        <ul className="pcb-debug-err-list">
          {visible.slice().reverse().map((e) => (
            <li key={e.id} className={`pcb-debug-err-item is-${e.level}`}>
              <div className="pcb-debug-err-head">
                <span className="pcb-debug-err-kind">{e.kind}</span>
                <span className="pcb-debug-err-time">{e.timestamp.slice(11, 19)}</span>
              </div>
              <div className="pcb-debug-err-msg">{e.message}</div>
              {e.stack && (
                <details>
                  <summary>stack</summary>
                  <pre className="pcb-debug-mono">{e.stack}</pre>
                </details>
              )}
              {e.componentStack && (
                <details>
                  <summary>component stack</summary>
                  <pre className="pcb-debug-mono">{e.componentStack}</pre>
                </details>
              )}
            </li>
          ))}
        </ul>
      )}
    </DebugSection>
  );
}
